import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { Button } from '@material-ui/core';
import { motion } from 'framer-motion';

import CloseIcon from 'public/icons/close-dark.svg';
import styles from 'styles/components/WhiteAlert.module.scss';

const buttonStyle = { height: 30, padding: '0 10px', marginTop: 15 };
const iconStyle = { position: 'absolute', right: 10, top: 5 };

const WhiteAlert = ({
  title,
  description,
  buttonText,
  iconSrc,
  alt,
  handleClick,
  handleClose,
  endIcon,
}) => (
  <motion.div
    className={styles.cardContainer}
    initial={{ x: -300, opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
  >
    <div className={styles.iconBackground}>
      <Image src={iconSrc} alt={alt} width={24} height={24} unoptimized />
    </div>

    <CloseIcon onClick={handleClose} style={iconStyle} />

    <div className={styles.content}>
      <h2>{title}</h2>
      <p>{description}</p>

      <Button
        color="primary"
        variant="contained"
        style={buttonStyle}
        endIcon={endIcon}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </div>
  </motion.div>
);

WhiteAlert.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  endIcon: PropTypes.node.isRequired,
};

export default WhiteAlert;
